import { useQuery } from '@tanstack/react-query'

import { getAssigneesFromDataAccessRequests } from 'services/data-access-requests'
import {
  DataAccessRequestQueryOptions,
  withDataAccessRequestsEnabled
} from 'services/data-access-requests/hooks/withDataAccessRequestsEnabled'
import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type { GetDataAccessRequestFilterAssigneesResponse } from 'services/data-access-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetAssigneesFromDataAccessRequests = (
  options?: DataAccessRequestQueryOptions<GetDataAccessRequestFilterAssigneesResponse, ApiErrorResponse>
) => {
  const { enabled: enabledOption, ...restOptions } = options ?? {}

  return useQuery<GetDataAccessRequestFilterAssigneesResponse, ApiErrorResponse>({
    queryKey: DataAccessRequestQueryKeys.FilterAssignees(),
    queryFn: ({ signal }) => getAssigneesFromDataAccessRequests({ signal }),
    enabled: withDataAccessRequestsEnabled(enabledOption ?? true),
    ...restOptions
  })
}
